import { growthBook } from 'services/GrowthBook/GrowthBookInstance';

export const isFeatureEnabled = (featureName: string): boolean => {
    return growthBook.isOn(featureName);
};
